import { RiProgress3Line, RiProgress4Line, RiProgress5Line, RiProgress6Line, RiProgress8Line } from '@/components/react-icons/main';

const workflowStageOptions = [
  { value: 'live', label: 'Live', icon: RiProgress8Line },
  { value: 'requirements', label: 'In Requirements', icon: RiProgress3Line },
  { value: 'development', label: 'In Development', icon: RiProgress4Line },
  { value: 'qa', label: 'In QA', icon: RiProgress5Line },
  { value: 'uat', label: 'Under User Acceptance Testing', icon: RiProgress6Line }
];

export default workflowStageOptions;
